module.exports = __webpack_public_path__ + "static/media/Holly McPhail Headshot.c5ac667c.jpeg";